import { Component, OnInit } from "@angular/core";
import { map } from "rxjs/operators";
import { SaveService } from "../services/save.service";
import { ApiService } from "../services/api.service";
import * as $ from "jquery";

@Component({
  selector: "app-how-works",
  templateUrl: "./how-works.component.html",
  styleUrls: ["./how-works.component.css"]
})
export class HowWorksComponent implements OnInit {
  brandName;
  pres_email: any = "";
  fullname: any = "";
  // first_name: any = "";
  last_name: any = "";
  tags: any = "";
  fullnameerror: any = "";
  errormessageLName: any = "";
  pres_emailerrorEmail: any = "";
  showsignupsucess: any = false;
  constructor(
    private saveService: SaveService,
    private ApiService: ApiService
  ) {}

  ngOnInit() {
    this.brandName = this.saveService.getBrandName();
  }

  submitCard(event) {
    event.stopImmediatePropagation();
    var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      this.fullname != "" &&
      this.pres_email != "" &&
      this.pres_email.match(mailformat)
    ) {
      this.ApiService.addActiveContact(
        this.pres_email,
        this.fullname,
        this.last_name,
        "HDWebsite"
      )
        .pipe(map(res => res.json()))

        .subscribe(data => {
          this.pres_email = "";
          this.fullname = "";
          this.showsignupsucess = true;
        });
    }
    if (this.fullname == "") {
      $("#fullnameerror")
        .css({ display: "block", color: "#f19f57" })
        .prev()
        .prev()
        .css("border-color", "#f19f57");
      this.fullnameerror = "Please enter your Full name";
    }
    if (this.pres_email != "" && !this.pres_email.match(mailformat)) {
      $("#pres_emailerror")
        .css({ display: "block", color: "#f19f57" })
        .prev()
        .prev()
        .css("border-color", "#f19f57");
      this.pres_emailerrorEmail = "Please enter a valid email address";
    }
    if (this.pres_email == "") {
      $("#pres_emailerror")
        .css({ display: "block", color: "#f19f57" })
        .prev()
        .prev()
        .css("border-color", "#f19f57");
      this.pres_emailerrorEmail = "Please enter a valid email address";
    }
  }

  removeerror(event) {
    $(event.target)
      .removeAttr("style")
      .next()
      .hide();
      this.showsignupsucess = false;
  }
}
